import { Col, Container, Row } from 'reactstrap';
import { useWarningsSummaryDetailsLoader } from '../loaders/StudentWarningsSummaryDetailsLoader';
import StudentWarningsSummaryDetailsBlock from './StudentWarningsSummaryDetailsBlock';

const StudentWarningsSummaryDetailsBlocks = () => {
  const { result } = useWarningsSummaryDetailsLoader();

  if (!result?.success || !result?.data) {
    return <></>;
  }

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        {result?.data?.warnings?.map((item, i) => (
          <Col xs={12} sm={6} className="pt-3" md={3} key={i.toString()}>
            <StudentWarningsSummaryDetailsBlock item={item} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryDetailsBlocks;
